// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type RechnungenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheZuweisbareEingangsrechnungenQuery = {
  korrekturBelegTyp?: string;
  search?: string;
  lieferantId?: string;
  bruttoBetrag?: number;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheZuweisbareEingangsrechnungen(): (
  korrekturRechnungId: string,
  query: SucheZuweisbareEingangsrechnungenQuery
) => Promise<RechnungenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (korrekturRechnungId, query = {}) =>
      (await getAPI()).rechnungen.sucheZuweisbareEingangsrechnungen({
        korrekturRechnungId,
        ...query,
      }),
    [getAPI]
  );
}
